import React from 'react';
import {
  CheckCircleIcon,
  ClockIcon,
  ArchiveBoxIcon,
  PauseCircleIcon,
} from '@heroicons/react/24/outline';

interface SequenceStatusBadgeProps {
  status: 'draft' | 'active' | 'paused' | 'archived';
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

export const SequenceStatusBadge: React.FC<SequenceStatusBadgeProps> = ({
  status,
  size = 'md',
  showIcon = true,
}) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  const statusConfig = {
    draft: {
      color: 'bg-gray-100 text-gray-800',
      icon: ClockIcon,
      label: 'Draft',
    },
    active: {
      color: 'bg-green-100 text-green-800',
      icon: CheckCircleIcon,
      label: 'Active',
    },
    paused: {
      color: 'bg-yellow-100 text-yellow-800',
      icon: PauseCircleIcon,
      label: 'Paused',
    },
    archived: {
      color: 'bg-gray-100 text-gray-800',
      icon: ArchiveBoxIcon,
      label: 'Archived',
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${config.color} ${sizeClasses[size]}`}
    >
      {showIcon && <Icon className={`${iconSizes[size]} mr-1`} />}
      {config.label}
    </span>
  );
};

